import React, {Component} from 'react';
import {DocType, getDocTypeLangKey} from "../definitions/DocType";
import styled from "styled-components";
import {
  emptyICountSsqDataByDocType,
  emptySquareCountOfEachDocTypeRequest,
  ICountOfEachDocTypeRequest,
  ICountsOfEachDocType,
  IGetSsqDataByPageRequest,
  ISsqDataDocument,
  SsqDataRepository
} from "../repositories/SsqDataRepository";
import {CategoryRepository} from "../repositories/category/CategoryRepository";
import {LanguageService} from "../language/LanguageService";
import CategoryStore from "../repositories/category/CategoryStore";
import {ErrorpageWrap, ViewmoreArea} from "../style/CommonStyledComponents";
import QnaDocListItem from "communitypage/qna/page/QnaDocListItem";
import {fontFamilyBold, fontFamilyMedium, fontFamilyRegular} from "style/fonts";
import {SsqImages} from "images/SsqImages";
import svcs from "services";
import {i18ns} from "language/i18nkey";
import {ISrchParam, SubTabButtons} from "productpage/ProductPage";
import {PERIOD_TYPE, SORT_TYPE} from "communitypage/common/CommunityFilter";

import {SwiperSlide} from "swiper/react";
import 'swiper/swiper.min.css';
import BlogDocumentListItem from "communitypage/blog/BlogDocumentListItem";
import {isEqual} from "lodash-es";
import {IfDocCommentInfo} from "models/IfSsqDataDocCommentEntity";
import {IfLoginInfo} from "models/IfLoginInfo";

interface Props {
  selectedCategoryId: number;
  languageService: LanguageService;
  categoryRepository: CategoryRepository;
  ssqDataRepository: SsqDataRepository;
  categoryStore: CategoryStore;
  getTranslation: Function;
  loadAllCategories: () => void;
  srchParam: ISrchParam;
  preSortType?: string;
  resetFilter?: Function;
  displayLoginPopup: Function;
  commentList: Array<IfDocCommentInfo>;
  loginInfo?: IfLoginInfo;
}


interface State {
  selectedDocType: string;
  ssqDataDocuments: ISsqDataDocument[];
  ssqDataVersion: string;
  ssqDataDocumentsCounts: ICountsOfEachDocType;
  pageNum: number;
  isMobile: boolean;
  isMounted: boolean;
}

class ProductSquareTabPanel extends Component<Props, State> {
  private readonly NO_DATA = "NO_DATA";
  private readonly PAGE_NUM_UNIT = 20;

  constructor(props: Props) {
    super(props);
    this.state = {
      selectedDocType: props.languageService.getLanguage() === 'en' ? DocType.TECH_GENERAL : DocType.QNA_Q,
      ssqDataDocuments: [],
      ssqDataVersion: "",
      ssqDataDocumentsCounts: emptyICountSsqDataByDocType,
      pageNum: 0,
      isMobile: false,
      isMounted: false,
    };
  }

  async componentDidMount() {
    const {selectedCategoryId} = this.props;
    await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));
    await this.getSsqDataDocuments(Number(selectedCategoryId));
    if (window.innerWidth < 1199)
      this.setState({isMobile: true});
    else
      this.setState({isMobile: false});
    this.setState({pageNum: 0});

    this.setState({
      isMounted: true,
    });
  }

  async componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    const selectedCategoryId = this.props.selectedCategoryId;

    if ((prevProps.selectedCategoryId !== selectedCategoryId) || !isEqual(prevProps.srchParam, this.props.srchParam)) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocumentsCounts(Number(selectedCategoryId));
      await this.getSsqDataDocuments(Number(selectedCategoryId));
    }

    if (prevState.selectedDocType != this.state.selectedDocType) {
      await this.getSsqDataDocuments(Number(selectedCategoryId));
      this.setState({pageNum: 0});
    }

    if (prevState.pageNum != this.state.pageNum && this.state.pageNum !== 0) {
      await this.getSsqDataDocuments(Number(selectedCategoryId), true);
    }

    if (prevProps.preSortType !== this.props.preSortType) {
      await this.setState({pageNum: 0});
      await this.getSsqDataDocuments(Number(selectedCategoryId));
    }
  }

  getDefaultSelectedTabForSquareTab(docCounts: ICountsOfEachDocType): string {
    return this.state.selectedDocType;

    if (docCounts.qnaCount > 0 && this.props.languageService.getLanguage() !== 'en')
      return DocType.QNA_Q;
    if (docCounts.techGeneralCount > 0)
      return DocType.TECH_GENERAL;
    //else return this.NO_DATA;
  }

  async getSsqDataDocuments(categoryId: number, pageChanged: boolean = false) {
    if (this.state.selectedDocType !== this.NO_DATA) {
      let getSsqDataByPageRequest: IGetSsqDataByPageRequest = {
        ...emptySquareCountOfEachDocTypeRequest,
        pageNum: this.state.pageNum,
        categoryId: categoryId,
        docTypes: [this.state.selectedDocType],
        exposeSiteLanguage: this.props.languageService.getLanguage(),
        sortType: this.props.srchParam.sortType === SORT_TYPE.RECENT ? 0 : this.props.srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
        periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
          this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
            this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
              this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
        tagType: this.props.srchParam.tagType,
        keyword: this.props.srchParam.keyword,
        userId: this.props.loginInfo.userId,
      };

      let ssqDataDocuments = await this.props.ssqDataRepository.getSsqDataByPage(getSsqDataByPageRequest);
      if (this.state.pageNum > 0 && pageChanged) {
        this.setState({ssqDataDocuments: [...this.state.ssqDataDocuments, ...ssqDataDocuments]});
      } else {
        this.setState({ssqDataDocuments});
      }
    } else {
      this.setState({ssqDataDocuments: []});
    }
  }

  async getSsqDataDocumentsCounts(categoryId: number) {
    let countOfEachDocTypeRequest: ICountOfEachDocTypeRequest = {
      ...emptySquareCountOfEachDocTypeRequest,
      categoryId: categoryId,
      exposeSiteLanguage: this.props.languageService.getLanguage(),
      sortType: this.props.srchParam.sortType === SORT_TYPE.RECENT ? 0 : this.props.srchParam.sortType === SORT_TYPE.UPDATE ? 1 : 2,
      periodType: this.props.srchParam.periodType === PERIOD_TYPE.DEFAULT ? 0 :
        this.props.srchParam.periodType === PERIOD_TYPE.WEEK ? 1 :
          this.props.srchParam.periodType === PERIOD_TYPE.ONEMONTH ? 2 :
            this.props.srchParam.periodType === PERIOD_TYPE.SIXMONTH ? 3 : 4,
      tagType: this.props.srchParam.tagType,
      keyword: this.props.srchParam.keyword,
      userId: this.props.loginInfo.userId,
    };

    let ssqDataDocumentsCounts =
      await this.props.ssqDataRepository.getCountsOfEachDocType(countOfEachDocTypeRequest);

    this.setState({
      selectedDocType: this.getDefaultSelectedTabForSquareTab(ssqDataDocumentsCounts),
      ssqDataDocumentsCounts
    });
  }

  isMoreDocumentsOnNextPage(documentCount: number) {
    return documentCount > this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  isRenderViewMoreSquareTab(docType: string) {
    if (docType === DocType.QNA_Q)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.qnaCount);
    else if (docType === DocType.TECH_GENERAL)
      return this.isMoreDocumentsOnNextPage(this.state.ssqDataDocumentsCounts.techGeneralCount);
  }

  countDocTypeWithSsqDataDocumentAll(docType: string): number | undefined {
    if (docType === DocType.QNA_Q && this.props.languageService.getLanguage() !== 'en')
      return this.state.ssqDataDocumentsCounts.qnaCount;
    else if (docType === DocType.TECH_GENERAL)
      return this.state.ssqDataDocumentsCounts.techGeneralCount;
    else
      return 0;
  }

  getPageCount() {
    return this.PAGE_NUM_UNIT * (this.state.pageNum + 1);
  }

  getTotalCount() {
    return this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType);
  }

  clickedTag(tag) {
  }

  docListItemTrans(key: string): string {
    svcs.svcLang.setNamespace(i18ns.cmmnty);
    return svcs.svcLang.getTranslationByKey(key) || "";
  }

  renderNoDocumentPageReset() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
        {
          !isEqual(this.props.srchParam, {
            sortType: '',
            periodType: '',
            tagType: [],
            categoryId: 0,
            keyword: '',
          }) &&
          <button className="error-button" onClick={() => this.props.resetFilter()}>
            {this.props.getTranslation("I18N_NO_DOCUMENT_RESET")}
          </button>
        }
      </div>
    </ErrorpageWrap>;
  }

  renderNoDocumentPage() {
    return <ErrorpageWrap className={"ErrorpageWrap"}>
      <div className={"Errorpage-product"}>
        <img alt={"empty_search_result.svg"} src={SsqImages.common.icon.emptySearchResult()}/>
        <p className={"error-tit"}>{this.props.getTranslation("I18N_NO_DOCUMENT")}</p>
        <p className={"error-txt"}>{this.props.getTranslation("I18N_NO_DOCUMENT_NOTICE")}</p>
      </div>
    </ErrorpageWrap>;
  }


  selectDocTypeCountNoDocumentPage() {
    if ((this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0) && this.props.srchParam.keyword !== "")
      return this.renderNoDocumentPageReset();

    if (this.props.srchParam.keyword == "" && (this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0 && this.getTabCnt() !== 0 ||
      this.countDocTypeWithSsqDataDocumentAll(this.state.selectedDocType) === 0))
      return this.renderNoDocumentPage();
  }

  renderDocumentTable() {
    return <>
      {this.state.selectedDocType === DocType.TECH_GENERAL ? <BlogContainer aria-label={"Blog-page"} className="blog_cont">
        <section className="community-body border-top-1">
          <div className={"wrapper container sub-container"}>
            <div className="community__content">
              <div className="content" style={{width: '100%'}}>
                <ul className="community-item">
                  {/*  문서 불러오는 부분*/}
                  {this.state.ssqDataDocuments.map((document) => {
                    return (<BlogDocumentListItem
                      commentList={this.props.commentList}
                      displayLoginPopup={this.props.displayLoginPopup}
                      key={document.id}
                      ssqDocument={document}
                      getTranslation={this.docListItemTrans}
                      languageService={this.props.languageService}
                      clickedTag={this.clickedTag}/>);
                  })}
                  {this.state.isMounted && this.selectDocTypeCountNoDocumentPage()}
                </ul>
              </div>
            </div>
          </div>
        </section>
      </BlogContainer> : <CommunityContentElement className="qna_cont">
        <div className="community__content">
          <div className="content">
            <CommunityContentListElement>
              <ul className="community-item">
                {this.state.ssqDataDocuments.map((document: any, index) => (
                  <QnaDocListItem
                    commentList={this.props.commentList}
                    displayLoginPopup={this.props.displayLoginPopup}
                    key={document.id}
                    ssqDocument={document}
                    ssqDataRepository={this.props.ssqDataRepository}
                    getTranslation={this.docListItemTrans}
                    languageService={this.props.languageService}
                    clickedTag={this.clickedTag}/>
                ))}
                {this.state.isMounted && this.selectDocTypeCountNoDocumentPage()}
              </ul>
            </CommunityContentListElement>
          </div>
        </div>
      </CommunityContentElement>}
    </>;
  }

  getTabCnt() {
    let cnt = 0;
    if (this.state.ssqDataDocumentsCounts.qnaCount > 0) cnt = cnt + 1;
    if (this.state.ssqDataDocumentsCounts.techGeneralCount > 0) cnt = cnt + 1;
    return cnt;
  };

  renderSubTabButton(docType: string) {
    const count = this.countDocTypeWithSsqDataDocumentAll(docType) || 0;

    if (this.state.isMounted && this.state.selectedDocType === docType && count != 0)
      return <div className={`tab-button selected`}
        onClick={() => {
          this.setState({
            selectedDocType: docType,
            pageNum: 0
          });
        }}>
        {this.props.getTranslation(getDocTypeLangKey(docType))} <span>{count}</span>
      </div>;

    return count > 0 && <SwiperSlide className={`tab-button ${this.state.selectedDocType === docType ? "selected" : ""}`}
      onClick={() => {
        this.setState({
          selectedDocType: docType,
          pageNum: 0
        });
      }}>
      {this.props.getTranslation(docType === DocType.TECH_GENERAL ? 'I18N_TECH_GENERAL' : getDocTypeLangKey(docType))} <span>{count}</span>
    </SwiperSlide>;
  }

  render() {
    return (
      <TabWrap className={`${this.state.selectedDocType === DocType.QNA_Q ? "qna_wrap" : "blog_wrap"}`}>
        <SubTabButtons>
          {this.renderSubTabButton(DocType.QNA_Q)}
          {this.renderSubTabButton(DocType.TECH_GENERAL)}
        </SubTabButtons>
        {this.state.selectedDocType != this.NO_DATA
          &&
          <SubTabTableArea className="table_cont">
            {this.renderDocumentTable()}
            {this.isRenderViewMoreSquareTab(this.state.selectedDocType) && <ViewmoreArea className="view-more-area">
              <div className="view-more-list-box">
                <div className={"ViewmoreBtn"}>
                  <button className={"view-more-button"} onClick={() => {
                    this.setState({pageNum: this.state.pageNum + 1});
                  }}>
                    {this.props.getTranslation("I18N_DOC_VIEW_MORE")}
                  </button>
                </div>
                <div className={"ViewmoreNum"}>
                  <span className={"page-count"}>{this.getPageCount()}</span>
                  <span>{this.getTotalCount()}</span>
                </div>
              </div>
            </ViewmoreArea>
            }
          </SubTabTableArea>
        }
      </TabWrap>
    );
  }
}

export default ProductSquareTabPanel;

const TabWrap = styled.div`

  @media screen and (min-width: 1200px) {
    &.blog_wrap .table_cont {
      background: #F7F8FB;
    }
  }
`;
const SubTabTableArea = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 3.2rem;

  .qna_cont {
    padding-top: 1.6rem;
  }
`;

const CommunityContentElement = styled.div`
  .community__content {
    display: flex;
    background: #fff;
  }

  .community__content > aside {
    width: 24rem;
    padding-top: 3.2rem;
  }

  .community__content > .content {
    padding: 0 3.2rem 0 3.2rem;
    width: 100%;
  }


  /*---------- 타블렛 사이즈 ----------*/
  @media screen and (max-width: 1199px) {
    .community__content {
      display: flex;
      flex-wrap: wrap;
    }

    .community__content > aside {
      width: 100%;
      padding: 3.2rem;
      padding-top: 2.4rem;
    }

    .community__content > .content {
      padding-bottom: 0;
      width: 100%;
    }
  }

  @media screen and (max-width: 764px) {
    .community__content {
      display: flex;
      flex-direction: column;
      background: #fff;
      margin-top: 2rem;

    }

    .community__content > .content {
      padding: 0;
      width: 100%;
    }
  }
`;

const CommunityContentListElement = styled.div`
  .community-item > li {
    margin-top: 2.4rem;
    padding-top: 2.4rem;
    border-top: 1px solid #EEF1F6;
    width: 100%;
  }

  .community-item > li:first-child {
    border: none;
    padding-top: 0;
    margin-top: 0;
  }


  .community-item > li .content-row {
    display: flex;
  }

  .community-item > li .qna-check {
    width: 5.6rem;
  }

  .community-item > li .write-body {
    width: calc(100% - 5.6rem);
    padding-top: 0.8rem;
  }

  .community-item > li .tag {
    padding-left: 5.6rem;
    word-break: break-all;
  }

  .community-item > li .tag span {
    color: #407DD8;
    font-size: 1.3rem;
    ${fontFamilyRegular};
    margin-right: 1rem;
    font-weight: 500;
    line-height: 1.8;
    cursor: pointer;
  }

  .community-item > li .tag span:hover {
    color: #25426D;
  }

  .qna-check {
    width: 100%;
  }

  .qna-check .icon-qna {
    width: 40px;
    height: 40px;
  }

  .qna-check .icon-qna.a {
    background: url(${SsqImages.community.icon.communityQnaCheck()}) no-repeat;
  }

  .qna-check .icon-qna.q {
    background: url(${SsqImages.community.icon.communityQnaQ()}) no-repeat;
  }

  .qna-check .icon-qna.a > span {
    color: #34A597;
    ${fontFamilyMedium};
    font-size: 1rem;
    padding: 0 0.2rem;
    display: inline;
  }

  .qna-check .icon-qna.q span {
    display: none; /* q상태에서는  span을 가림 */
  }

  .qna-check .qna-ans-num {
    width: 1.8rem;
    height: 1.8rem;
    background: url(${SsqImages.community.icon.communityQnaSmallA()}) no-repeat .2rem center;
    padding-left: 2.2rem;
    font-size: 1.2rem;
    font-weight: 700;
    margin-top: .6rem;
    height: 2rem;
    line-height: 1.8;
  }

  .community-item .title-line p.write-title {
    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
    }

    ${fontFamilyBold};
    color: #2A2C2F;
    font-size: 1.8rem;
    line-height: 2.6rem;
    width: calc(100% - 5rem);
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    cursor: pointer;
  }

  .community-item > li p.write-content {
    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
    }

    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    color: #2A2C2F;
    font-size: 1.3rem;
    ${fontFamilyRegular};
    line-height: 1.8rem;
    margin-top: 0.5rem;
    width: 100%;
    text-overflow: clip;
    white-space: normal;
    overflow: hidden;
    cursor: pointer;
  }

  .community-item p.write-title span {
    padding: 0 2rem;
    background: #407EDB;
    color: #fff;
    border-radius: 10rem;
    font-size: 1rem;
    height: 2rem;
    display: inline-block;
    line-height: 2rem;
    margin-right: 1rem;
    font-weight: 400;
    vertical-align: middle;
  }

  ul.comment-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 1.6rem;
    align-items: center;
  }

  ul.comment-box > li {
    margin-right: 1rem;
    font-size: 1.2rem;
    ${fontFamilyRegular};
    color: #7783A1;
    font-weight: 500;
    line-height: 2.4;
  }

  ul.comment-box .c-name {
    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
      font-weight: initial;
    }

    color: #2A2C2F;
  }

  ul.comment-box .c-name span {
    width: 2.2rem;
    height: 2.2rem;
    display: inline-block;
    vertical-align: middle;
    border: 1px solid #F7B91B;
    border-radius: 2rem;
    overflow: hidden;
    margin-right: .4rem;
  }

  ul.comment-box .c-name span.unknown {
    border: none;
  }

  ul.comment-box .c-time {
    background-image: url("${SsqImages.community.icon.communityTime()}");
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 1.8rem;
    //margin-left: .8rem;
    ${fontFamilyRegular};
  }

  ul.comment-box .c-view {
    color: #407EDB;
    background-image: url("${SsqImages.community.icon.communityView()}");
    background-repeat: no-repeat;
    background-position: left center;
    padding-left: 1.8rem;
    ${fontFamilyRegular};
  }

  ul.comment-box .c-good {
    color: #407EDB;
    padding-left: 1.8rem;
    background-image: url("${SsqImages.community.icon.communityGood()}");
    background-repeat: no-repeat;
    background-position: left center;
  }

  ul.comment-box .c-not-bad {
    color: #FF215D;
    padding-left: 1.8rem;
    background-image: url("${SsqImages.community.icon.communityNotBad()}");
    background-repeat: no-repeat;
    background-position: left center;
  }

  ul.comment-box .c-txt {
    ${fontFamilyBold};
    height: 1.8rem;
    line-height: 1.8rem;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 2rem;
    margin-right: .4rem;
  }


  ul.comment-box .c-txt.expert {
    color: #34A597;
    background: #EBF6F5;
  }

  ul.comment-box .c-txt.employee {
    color: #7783A1;
    background: rgba(119, 131, 161, 0.10);
  }

  @media screen and (max-width: 1199px) {
    .community-item .title-line p.write-title {
      width: 100%;
      white-space: normal;
    }

    .community-item > li p.write-content {
      width: 100%;
      text-overflow: clip;
      white-space: normal;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }

  @media screen and (max-width: 764px) {
    .community-item > li {
      box-shadow: none;
      padding: 1.6rem;
      margin-top: 0;
    }

    .community-item > li:first-child {
      padding: 0 1.6rem 1.6rem 1.6rem;
    }

    .community-item > li .write-body {
      margin-right: 0;
      flex: 1;
    }

    .community-item > li:first-child .write-body {
      border: none;
    }

    .community-item > li .tag span {
      color: #407DD8;
      font-size: 1.3rem;
      margin-right: 1.2rem;
      font-weight: 500;
    }

    .community-item > li .tag span.post-kind {
      color: #7783A1;
      font-size: 1.2rem;
    }


    .community-item .title-line p.write-title {
      width: 100%;
      white-space: normal;
    }

    .community-item > li p.write-content {
      width: 100%;
      text-overflow: clip;
      white-space: normal;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
  }
`;

export const BlogContainer = styled.div`

  //내용 제목 임직원 타이틀 위치

  .lv-info {
    height: 1.8rem;
    line-height: 1.8rem;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 2rem;
    display: inline-block;
    vertical-align: middle;
    margin: 0 0 0.4rem 0.4rem;
  }

  //내용 제목 임직원 타이틀 색상

  .lv-worker {
    background: #7783A1 !important;
    color: #fff !important;
  }

  //전체 화면 색

  section.community-body {
    background: #EEF1F6;
    position: relative;
    top: 0rem;
    min-height: calc(100% - 60px);
  }

  section.community-body.border-top-1 {
    border-top: .1rem solid #C7D6EA;
  }

  //나오는 부분 시작화면

  .sub-container {
    box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  }

  //내용화면

  .community__content {
    display: flex;
    background: #F7F8FB;
  }

  //사이드

  .community__content > aside {
    width: 24rem;
    padding-top: 3.2rem;
  }

  //내용 속 디테일 내용

  .community__content > .content {
    padding: 3.2rem 3.2rem 0;
    width: calc(100% - 24rem);
  }

  //제목,사람, 책 사진부분

  .community__header {
    background: #fff;
    color: #fff;
    padding: 4rem 4rem 2.4rem 4rem;
    position: relative;
  }

  //select부분

  .community-item > li {
    margin-top: 2.4rem;
    width: 100%;
  }

  .community-item > li:first-child {
    margin-top: 0;
  }

  //하늘색부분

  .visual-item {
    height: 20rem;
    background: #ECF2FB;
    border-radius: 48px;
    width: 100%;
    position: relative;
    margin: 0 0.8rem;
  }

  //사람 사진

  .visual-item .bg-human {
    width: 20rem;
    height: 28rem;
    background-image: url(${SsqImages.community.visualBlogPerson()});
    background-repeat: no-repeat;
    position: absolute;
    top: -4rem;
    right: 10rem;
  }

  //책사진

  .visual-item .bg-qna {
    width: 10rem;
    height: 10rem;
    background-image: url(${SsqImages.community.visualBlogBook()});
    background-repeat: no-repeat;
    position: absolute;
    top: 5rem;
    right: 32rem;
  }

  //글자들

  .visual-text {
    position: absolute;
    top: 8rem;
    left: 10.4rem;
    color: #2A2C2F;
  }

  .visual-text > p.v-txt-lg {
    font-size: 2.4rem;
    line-height: 3.6rem;
  }

  .visual-text > p.v-txt-sm {
    font-size: 1.4rem;
    font-weight: 500;
    line-height: 2.1rem;
  }

  //글쓰기 버튼 상자

  .btn-box {
    width: 13.2rem;
    height: 4.8rem;
    border-radius: .4rem;
    font-size: 1.6rem;
    ${fontFamilyBold};
  }

  //버튼 색상

  .btn-box.btn-write {
    background: #407EDB;
    color: #fff;
    margin-top: 1.6rem;
  }

  //내용 박스

  .community-item > li {
    display: flex;
    background: #fff;
    box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    overflow: hidden;
  }

  //내용 박스 하나하나

  .community-item > li .write-body {
    width: 100%;
    padding: 1.5rem 3.2rem 1.8rem 3.2rem;
    //margin-right: 3.2rem;
    cursor: pointer;
  }

  //내용박스 속 젤 앞 태그

  .community-item > li .tag {
    padding: .3rem 0;
  }

  //내용박스 속 두번째 태그 부분

  .community-item > li .tag span {
    color: #407DD8;
    font-size: 1.3rem;
    ${fontFamilyRegular};
    margin-right: 1rem;
    font-weight: 500;
    line-height: 1.8;
    cursor: pointer;
    display: inline-block;
  }

  .community-item > li .tag span:hover {
    color: #25426D;
  }

  .community-item > li .tag span.post-kind {
    color: #7783A1;
  }

  //내용 사진

  .community-item > li .blog-img {
    width: 16rem;
    min-height: 16rem;
    flex-shrink: 0;
    border-radius: 0 0.4rem 0.4rem 0;
  }

  // 내용제목

  .community-item .blog-title p.write-title {
    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
    }

    color: #2A2C2F;
    font-size: 1.8rem;
    ${fontFamilyBold};
    line-height: 2.6rem;
    width: 100%;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    margin-top: 1rem;
  }

  //내용

  .community-item > li p.write-content {
    .search_highlight {
      background: linear-gradient(to top, #FFFAA0 50%, transparent 50%) !important;
    }

    -webkit-line-clamp: 1;
    -webkit-box-orient: vertical;
    display: -webkit-box;
    color: #2A2C2F;
    font-size: 1.3rem;
    ${fontFamilyRegular};
    line-height: 1.8rem;
    margin-top: 0.5rem;
    width: 100%;
    text-overflow: clip;
    overflow: hidden;
    cursor: pointer;
  }

  //모바일 버전 이미지

  .community-item .blog-content .blog-mobile-img {
    display: none;
  }


  //키워드 검색


  .mobile-black {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 9;
    background: rgba(0, 0, 0, .5);
    display: none;
  }

  /*내용 속 하단의 임직원, 시간, 조회수 등*/

  ul.comment-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 1rem;
    align-items: center;
  }

  ul.comment-box > li {
    margin-right: 1rem;
    font-size: 1.2rem;
    ${fontFamilyRegular};
    color: #7783A1;
    font-weight: 500;
    line-height: 2.4;
  }

  ul.comment-box .c-name {
    color: #2A2C2F;
  }

  ul.comment-box .c-name span {
    width: 2.2rem;
    height: 2.2rem;
    display: inline-block;
    vertical-align: middle;
    border: 1px solid #F7B91B;
    border-radius: 2rem;
    overflow: hidden;
    margin-right: .4rem;
  }

  ul.comment-box .c-name span.unknown {
    border: none;
  }

  ul.comment-box .c-time {
    background-image: url("${SsqImages.community.icon.communityTime()}");
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 1.6rem;
    padding-left: 1.8rem;
    //margin-left: .8rem;
    ${fontFamilyRegular};
  }

  ul.comment-box .c-view {
    color: #407EDB;
    background-image: url("${SsqImages.community.icon.communityView()}");
    background-repeat: no-repeat;
    background-position: left center;
    background-size: 1.6rem;
    padding-left: 1.8rem;
    ${fontFamilyRegular};
  }

  ul.comment-box .c-good {
    color: #407EDB;
    padding-left: 1.8rem;
    background-image: url("${SsqImages.community.icon.communityGood()}");
    background-repeat: no-repeat;
    background-position: left center;
  }

  ul.comment-box .c-not-bad {
    color: #FF215D;
    padding-left: 1.8rem;
    background-image: url("${SsqImages.community.icon.communityNotBad()}");
    background-repeat: no-repeat;
    background-position: left center;
  }

  ul.comment-box .c-txt {
    ${fontFamilyMedium};
    height: 1.8rem;
    line-height: 1.8rem;
    padding: 0 1rem;
    font-size: 1rem;
    border-radius: 2rem;
    margin-right: 0.4rem;
  }

  /*데이터 리스트 하단의 점수 색상*/

  ul.comment-box .c-txt.count.first {
    color: #EDAE0A;
    background: rgba(247, 185, 27, 0.10);

  }

  ul.comment-box .c-txt.count.second {
    color: #FF7A00;
    background: #FFE4CC;
  }

  ul.comment-box .c-txt.count.third {
    color: #7B5DF1;
    background: #E5DFFC;
  }

  ul.comment-box .c-txt.count.fourth {
    color: #407EDB;
    background: #D9E5F8;
  }

  ul.comment-box .c-txt.count.fifth {
    color: #7C899E;
    background: #E5E7EC;
  }

  ul.comment-box .c-txt.expert {
    color: #34A597;
    background: #EBF6F5;
  }

  ul.comment-box .c-txt.employee {
    color: #7783A1;
    background: rgba(119, 131, 161, 0.10);
  }


  /*모바일 버전 하단 footer 메뉴*/

  .commonity-footer-menu {
    display: none;
  }

  .inquiry-box .inquiry-list {
    display: flex;
  }

  /*---------- 타블렛 사이즈 ----------*/

  @media (min-width: 768px) and (max-width: 1199px) {


    .visual-item .bg-qna {
      display: none;
    }

    .visual-item .bg-human {
      background-image: url("${SsqImages.community.visualBlogPerson()}");
      background-repeat: no-repeat;
      background-position: 5rem center;
      top: -4rem;
      right: -3rem;
    }

    .community__content {
      display: flex;
      flex-wrap: wrap;
    }

    .community__content > aside {
      width: 100%;
      padding: 3.2rem;
      padding-top: 2.4rem;
    }

    .best-item {
      display: flex;
    }

    .best-item > div {
      width: 33%;
      margin-top: 2rem;
    }

    .best-item .tag-best {
      padding-right: 3rem;
    }

    .tag-best > .tag-content > li {
      padding: 0.7rem 1rem
    }

    .tag-best-mem .best-men-item {
      margin-top: 0.8rem;
    }

    .tag-best-qna > ul > li {
      padding: 0.5rem 0;
    }

    .tag-best-qna .best-content {
      width: auto;
    }

    .community__content > .content {
      padding: 3.2rem;
      padding-bottom: 0;
      width: 100%;
    }

    .community-item > li p.write-content {
      width: 100%;
      text-overflow: clip;
      white-space: normal;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
    }

  }

  /*---------- 모바일 사이즈 ----------*/

  @media screen and (max-width: 764px) {


    margin-top: 4rem;

    .btn-filter {
      display: block;
      margin-right: 1.6rem;
    }

    .community__content {
      display: flex;
      flex-direction: column;
      background: #fff;
    }

    .community__header {
      padding: 0;
    }

    .visual-item {
      height: 30rem;
      border-radius: 0;
      width: 100%;
      margin: 0;
    }

    .visual-item .bg-human {
      width: 10rem;
      height: 14rem;
      background-size: cover;
      position: absolute;
      top: 15rem;
      right: 4rem;
    }

    .visual-item .bg-qna {
      width: 10rem;
      height: 10rem;
      position: absolute;
      top: 5rem;
      right: 32rem;
      display: none;
    }

    .visual-text {
      position: absolute;
      height: 100%;
      width: 100%;
      padding: 0 4rem;
      top: 4rem;
      left: 0;
      bottom: 0;
    }

    .visual-text > p.v-txt-lg {
      font-size: 2.4rem;
      line-height: 3.6rem;
    }

    .visual-text > p.v-txt-sm {
      font-size: 1.4rem;
      font-weight: 500;
      line-height: 2.1rem;
      margin-top: 1.2rem;
    }

    .btn-box.btn-write {
      position: absolute;
      top: 16rem;
    }

    aside.community-aside {
      display: none;
    }

    .community__content > .content {
      padding: 0;
      width: 100%;
    }

    .community-item > li {
      box-shadow: none;
      padding: 0 1.6rem;
      margin-top: 0;
    }

    .community-item > li .write-body {
      width: 100%;
      padding: 1.5rem 0;
      margin-right: 0;
      border-top: 1px solid #C7D6EA;
      box-sizing: border-box;
    }

    .community-item > li:first-child .write-body {
      border: none;
    }

    .community-item > li .tag {
      padding: .3rem 0;
    }

    .community-item > li .tag span {
      color: #407DD8;
      font-size: 1.3rem;
      margin-right: 1.2rem;
      font-weight: 500;
    }

    .community-item > li .blog-img {
      display: none;
    }

    .community-item .blog-title p.write-title {
      color: #2A2C2F;
      font-size: 1.8rem;
      line-height: 2.8rem;
      width: 100%;
      text-overflow: clip;
      white-space: normal;
      overflow: inherit;
      margin-top: 1rem;
    }

    .community-item > li p.write-content {
      width: 100%;
      text-overflow: clip;
      white-space: normal;
      overflow: hidden;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      margin-top: 0;
    }

    .community-item .blog-content {
      display: flex;
      margin-top: 0.5rem;
    }

    .community-item .blog-content .blog-content-item {
      width: 100%;
    }

    .community-item .blog-content .blog-mobile-img {
      display: block;
      width: 9rem;
      height: 9rem;
      background: #F6F8FB;
      border: 1px solid #EEF1F5;
      border-radius: .4rem;
      position: relative;
      flex-shrink: 0;
      margin-right: 1rem;


    }

    .community-item .blog-content .blog-mobile-img img {
      width: 100%;
      height: 100%;
      object-fit: contain;
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      margin: auto;
    }


    ul.comment-box {
      display: flex;
      flex-wrap: wrap;
      margin-top: .5rem;
    }

  }
`;
